import React, { useState, useEffect } from "react";
import axios from "axios";
import Layout from "../../../../components/AdminLayout";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Editor } from "@tinymce/tinymce-react";
import AdminLayout from "../../../../components/AdminLayout";
import { toast } from "react-toastify";

const SeatingApp = () => {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [seatingApp, setSeatingApp] = useState([]);

  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const fetchSeatingApp = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const response = await axios.get(`${apiUrl}/api/seating-application`);
        const seatingAppData = response.data.seatingApp;

        setSeatingApp(seatingAppData);
       
      } catch (error) {
        console.error("Error fetching application:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSeatingApp();
  }, []);

  const handleDeleteApplication = async (id, name) => {
    const confirmDelete = window.confirm(
      `Are you sure you want to delete this "${name}" application?`
    );
    if (!confirmDelete) return;

    try {
      const access_token = localStorage.getItem("access_token");
      const apiUrl = process.env.REACT_APP_API_URL;

      const response = await axios.delete(
        `${apiUrl}/api/seating-application/${id}`,
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      console.log(response.data);
      setSeatingApp((prev) => prev.filter((app) => app._id !== id));
      setTimeout(() => {
        navigate("/admin/seating-applications");
      }, 3000);

              toast.success("Seating component application deleted successfully!");
      
    } catch (error) {
      console.error("Error deleting application:", error);
      setErrorMessage(
        error.response?.data?.message || "Failed to delete application"
      );

              toast.error("Failed to delete seating component application");
      
    }
  };

  return (
    <AdminLayout>
      <div className="pages-headers ">
        <h2>
          seating Applications
          <NavLink to="/admin/add/seating-applications" className="theme-cta">
            <i className="las la-plus-circle"></i>
            Add seating Application
          </NavLink>
        </h2>
      </div>
      <div className="row mobilerows">
        <div className="col-md-12">
          <div className="infos-table">
            <div className="table-responsive">
              <table id="example" className="table nowrap">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th className="text-center">Image</th>
                    <th className="text-center">Alt</th>
                    <th className="text-center">Content</th>
                    <th className="text-center">Sequence</th>

                    <th className="text-center">Edit</th>
                  </tr>
                </thead>
                <tbody>
                  {seatingApp &&
                    seatingApp.map((app) => (
                      <tr key={app._id}>
                        <td>{app.name}</td>

                        <td className="text-center">
                          {app.image[0]?.filepath && (
                            <img
                              src={app.image[0]?.filepath}
                              alt={app.alt}
                              style={{
                                width: "100px",
                                height: "100px",
                              }}
                              loading="lazy"
                            />
                          )}
                        </td>
                        <td className="text-center"> {app.alt}</td>
                        <td className="text-center"> {app.content}</td>
                        <td className="text-center"> {app.sequence}</td>

                        <td className="text-center">
                          <Link
                            to={`/admin/edit/seating-applications/${app._id}`}
                            title="Edit"
                          >
                            <i className="las la-pencil-alt"></i>
                          </Link>
                        </td>
                        <td className="text-center">
                          <button
                            className="delete-btn"
                            onClick={() =>
                              handleDeleteApplication(app._id, app.name)
                            }
                          >
                            <i className="las la-trash"></i>{" "}
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default SeatingApp;
